/**
 * Tornillos vivos de una placa del parque: la interaccion firma.
 *
 * Van dentro de una `Card` con la clase `plate-live-bolts`, que oculta los
 * tornillos fijos. Huecos sin compromiso; rellenos cuando el atleta se ha
 * inscrito o ha enviado. `animate` solo en el momento del cambio: el
 * movimiento comunica que acaba de pasar algo, no decora cada visita.
 *
 * Las clases van escritas enteras (no `bolt-${esquina}`) para que Tailwind
 * las encuentre al generar el CSS.
 */
const CORNERS = ['bolt bolt-tl', 'bolt bolt-tr', 'bolt bolt-br', 'bolt bolt-bl'];

export function Bolts({ set, animate = false }: { set: boolean; animate?: boolean }) {
  return (
    <>
      {CORNERS.map((className) => (
        <span
          key={className}
          className={className}
          data-set={set}
          data-animate={set && animate}
          aria-hidden="true"
        />
      ))}
    </>
  );
}
